export const replaceImg = (str = "") => {
  if (/(.summ.|.search.)/.test(str)) {
    return str.replace(/(.summ.|.search.)/g, ".300x300.");
  } else if (str.includes("cib.")) {
    return str.replace(/cib./, "cib.300x300.");
  }
  return str;
};


